/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IWorld__factory } from "./IWorld__factory";
